import { useCallback } from 'react'

import { useIsUnmounted } from '@/hooks'

import type { UpdateCompanyDetailsPayload } from '../../../../../sections/setup/pages/notifications/forms/TrackingPage/types'

import { TrackingPageFormValues } from '../typings'

export function useOnSubmit(
  updateTrackingAppData: (payload: UpdateCompanyDetailsPayload) => Promise<boolean>,
  clearEditingState: () => void,
) {
  // track the mounted state of the parent component
  const isUnmounted = useIsUnmounted()

  return useCallback(
    async (formValues: TrackingPageFormValues) => {
      const result = await updateTrackingAppData(formValues)

      if (isUnmounted()) return

      if (result) clearEditingState()
    },
    [clearEditingState, isUnmounted, updateTrackingAppData],
  )
}
